import '@coreui/coreui/dist/js/bootstrap.bundle.min.js'

export default defineNuxtPlugin(() => {
})
